import { render, staticRenderFns } from "./instagram-grid.vue?vue&type=template&id=7f4d6c5f&scoped=true&"
import script from "./instagram-grid.vue?vue&type=script&lang=js&"
export * from "./instagram-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4d6c5f",
  null
  
)

export default component.exports